import React, { useCallback, useEffect } from 'react';
import KeyboardFormField from '@common/components/keyboardFormField';
import { useDataFetch } from '@common/hooks/dataFetch';
import PropTypes from 'prop-types';
import { isValidCPF, validateCpf } from '@common/helpers/validateCpf';
import { fields } from '../constants/fields';

export const CpfRegistrationWithAutoFill = ({
  form, setForm, errors, setErrors,
}) => {
  const [data] = useDataFetch(() => isValidCPF(form.cpf) && validateCpf(form.cpf), [form.cpf]);

  useEffect(() => {
    if (data && !data.errorMessage && !form.FirstName && isValidCPF(form.cpf)) {
      setForm({
        ...form,
        ...data,
        BirthDate: data.BirthDate,
      });

      setErrors({
        ...errors,
        cpf: '',
      });
    }
  }, [data, form, setForm, setErrors, errors]);

  const clearCpfInfo = useCallback(() => setForm({
    ...form,
    firstName: '',
    lastName: '',
    birthDate: '',
  }), [form, setForm]);

  useEffect(() => {
    if (data && data.errorMessage) {
      const cpfError = `Invalid CPF (${data.errorMessage})`;

      if (cpfError !== errors.cpf) {
        setErrors({ ...errors, cpf: cpfError });
        clearCpfInfo();
      }
    };
  }, [data, clearCpfInfo, setErrors, errors]);

  useEffect(() => {
    if (form.FirstName && !isValidCPF(form.cpf)) clearCpfInfo();
  }, [form, clearCpfInfo]);

  const onChange = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  return (
    <div className="popup-main-content popup-register-wide-form">
      <div className="input-wrapper">
        {fields.map((item) => (
          <div className="register-single-input">
            <KeyboardFormField
              readOnly={item.readOnly}
              key={item.name}
              type={item.type}
              name={item.fieldName}
              value={form[item.name]}
              onChange={(value) => onChange(item.name, item.formatter ? item.formatter(value) : value)}
              errorMessage={errors[item.name]}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

CpfRegistrationWithAutoFill.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func,
  setErrors: PropTypes.func,
  errors: PropTypes.object,
};
